import blogicon from "../images/blogIcon.png";
import blogCardImg from "../images/blogCardImg.svg";

const Blog = () => {
  return (
    <div className="py-8 px-2 md:px-8 ">
      <section className="max-w-[1400px] mx-auto">
      <div className="flex ">
        <img className="w-[60px] mr-3" src={blogicon} alt="Blog" />
        <div>
          <h3 className="text-yellow-400 font-semibold text-2xl">
            Blog Articles
          </h3>
          <p className="text-lg font-semibold">SwissGold Blog Articles</p>
        </div>
      </div>
      <div className="flex flex-col place-items-center" >
        <div className="mt-5 w-fit place-items-center-center gap-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ">
          <div className="m-2 border border-yellow-400 w-[290px] rounded-3xl">
            <img className="rounded-t-3xl" src={blogCardImg} alt="img" />
            <div className="p-3 text-yellow-400">
              <p className="text-sm mt-2">Olivia Rhye • 20 Jan 2024</p>
              <h3 className="text-lg font-semibold mt-2">
                UX review presentations
              </h3>
              <p className="text-yellow-100 mt-2">
                How do you create compelling presentations that wow your
                colleagues and impress your managers?
              </p>
              <button className="border hover:scale-105 transition-transform ease-in-out duration-300 border-yellow-400 rounded-3xl py-1 mt-2 px-2">
                Gold News
              </button>
            </div>
          </div>
          <div className="m-2 border border-yellow-400 w-[290px] rounded-3xl">
            <img className="rounded-t-3xl" src={blogCardImg} alt="img" />
            <div className="p-3 text-yellow-400">
              <p className="text-sm mt-2">Olivia Rhye • 20 Jan 2024</p>
              <h3 className="text-lg font-semibold mt-2">
                UX review presentations
              </h3>
              <p className="text-yellow-100 mt-2">
                How do you create compelling presentations that wow your
                colleagues and impress your managers?
              </p>
              <button className="border hover:scale-105 transition-transform ease-in-out duration-300 border-yellow-400 rounded-3xl py-1 mt-2 px-2">
                Gold News
              </button>
            </div>
          </div>
          <div className="m-2 border border-yellow-400 w-[290px] rounded-3xl">
            <img className="rounded-t-3xl" src={blogCardImg} alt="img" />
            <div className="p-3 text-yellow-400">
              <p className="text-sm mt-2">Olivia Rhye • 20 Jan 2024</p>
              <h3 className="text-lg font-semibold mt-2">
                UX review presentations
              </h3>
              <p className="text-yellow-100 mt-2">
                How do you create compelling presentations that wow your
                colleagues and impress your managers?
              </p>
              <button className="border hover:scale-105 transition-transform ease-in-out duration-300 border-yellow-400 rounded-3xl py-1 mt-2 px-2">
                Gold News
              </button>
            </div>
          </div>
          <div className="m-2 border border-yellow-400 w-[290px] rounded-3xl">
            <img className="rounded-t-3xl" src={blogCardImg} alt="img" />
            <div className="p-3 text-yellow-400">
              <p className="text-sm mt-2">Olivia Rhye • 20 Jan 2024</p>
              <h3 className="text-lg font-semibold mt-2">
                UX review presentations
              </h3>
              <p className="text-yellow-100 mt-2">
                How do you create compelling presentations that wow your
                colleagues and impress your managers?
              </p>
              <button className="border hover:scale-105 transition-transform ease-in-out duration-300 border-yellow-400 rounded-3xl py-1 mt-2 px-2">
                Gold News
              </button>
            </div>
          </div>
          <div className="m-2 border border-yellow-400 w-[290px] rounded-3xl">
            <img className="rounded-t-3xl" src={blogCardImg} alt="img" />
            <div className="p-3 text-yellow-400">
              <p className="text-sm mt-2">Olivia Rhye • 20 Jan 2024</p>
              <h3 className="text-lg font-semibold mt-2">
                UX review presentations
              </h3>
              <p className="text-yellow-100 mt-2">
                How do you create compelling presentations that wow your
                colleagues and impress your managers?
              </p>
              <button className="border hover:scale-105 transition-transform ease-in-out duration-300 border-yellow-400 rounded-3xl py-1 mt-2 px-2">
                Gold News
              </button>
            </div>
          </div>
          <div className="m-2 border border-yellow-400 w-[290px] rounded-3xl">
            <img className="rounded-t-3xl" src={blogCardImg} alt="img" />
            <div className="p-3 text-yellow-400">
              <p className="text-sm mt-2">Olivia Rhye • 20 Jan 2024</p>
              <h3 className="text-lg font-semibold mt-2">
                UX review presentations
              </h3>
              <p className="text-yellow-100 mt-2">
                How do you create compelling presentations that wow your
                colleagues and impress your managers?
              </p>
              <button className="border hover:scale-105 transition-transform ease-in-out duration-300 border-yellow-400 rounded-3xl py-1 mt-2 px-2">
                Gold News
              </button>
            </div>
          </div>
          <div className="m-2 border border-yellow-400 w-[290px] rounded-3xl">
            <img className="rounded-t-3xl" src={blogCardImg} alt="img" />
            <div className="p-3 text-yellow-400">
              <p className="text-sm mt-2">Olivia Rhye • 20 Jan 2024</p>
              <h3 className="text-lg font-semibold mt-2">
                UX review presentations
              </h3>
              <p className="text-yellow-100 mt-2">
                How do you create compelling presentations that wow your
                colleagues and impress your managers?
              </p>
              <button className="border hover:scale-105 transition-transform ease-in-out duration-300 border-yellow-400 rounded-3xl py-1 mt-2 px-2">
                Gold News
              </button>
            </div>
          </div>
          <div className="m-2 border border-yellow-400 w-[290px] rounded-3xl">
            <img className="rounded-t-3xl" src={blogCardImg} alt="img" />
            <div className="p-3 text-yellow-400">
              <p className="text-sm mt-2">Olivia Rhye • 20 Jan 2024</p>
              <h3 className="text-lg font-semibold mt-2">
                UX review presentations
              </h3>
              <p className="text-yellow-100 mt-2">
                How do you create compelling presentations that wow your
                colleagues and impress your managers?
              </p>
              <button className="border hover:scale-105 transition-transform ease-in-out duration-300 border-yellow-400 rounded-3xl py-1 mt-2 px-2">
                Gold News
              </button>
            </div>
          </div>
          <div className="m-2 border border-yellow-400 w-[290px] rounded-3xl">
            <img className="rounded-t-3xl" src={blogCardImg} alt="img" />
            <div className="p-3 text-yellow-400">
              <p className="text-sm mt-2">Olivia Rhye • 20 Jan 2024</p>
              <h3 className="text-lg font-semibold mt-2">
                UX review presentations
              </h3>
              <p className="text-yellow-100 mt-2">
                How do you create compelling presentations that wow your
                colleagues and impress your managers?
              </p>
              <button className="border hover:scale-105 transition-transform ease-in-out duration-300 border-yellow-400 rounded-3xl py-1 mt-2 px-2">
                Gold News
              </button>
            </div>
          </div>
          
        </div>
      </div>
      </section>
    </div>
  );
};

export default Blog;
